import React from "react";
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface RowDetailsModalProps {
    open: boolean;
    onClose: () => void;
    rowData: Record<string, any> | null;
}

const RowDetailsModal: React.FC<RowDetailsModalProps> = ({ open, onClose, rowData }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: "8px",
                    boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
                },
            }}
        >
            <DialogTitle
                sx={{
                    py: 1,
                    px: 2,
                    fontSize: "0.9rem",
                    fontWeight: 600,
                    borderBottom: "1px solid #e0e0e0",
                    backgroundColor: "#f8f9fa",
                }}
            >
                Row Details
                <IconButton
                    onClick={onClose}
                    size="small"
                    sx={{
                        position: "absolute",
                        right: 6,
                        top: 6,
                        color: "#666",
                        padding: "4px",
                        "&:hover": { backgroundColor: "rgba(0,0,0,0.08)" },
                    }}
                >
                    <CloseIcon sx={{ fontSize: "1.1rem" }} />
                </IconButton>
            </DialogTitle>

            <DialogContent sx={{ p: 0 }}>
                {rowData && (
                    <Box sx={{ py: 0.5 }}>
                        {Object.entries(rowData)
                            .filter(([key]) => !key.startsWith("_"))
                            .map(([key, value], index, array) => (
                                <Box
                                    key={key}
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        px: 2,
                                        py: 0.5,
                                        minHeight: "32px",
                                        backgroundColor: index % 2 === 0 ? "#fff" : "#fafafa",
                                        "&:hover": { backgroundColor: "#f0f0f0" },
                                        borderBottom:
                                            index === array.length - 1 ? "none" : "1px solid #f0f0f0",
                                    }}
                                >
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            fontWeight: 600,
                                            minWidth: "120px",
                                            maxWidth: "120px",
                                            fontSize: "0.7rem",
                                            textTransform: "capitalize",
                                            color: "#555",
                                            pr: 1.5,
                                            lineHeight: 1.4,
                                        }}
                                    >
                                        {key.replace(/_/g, " ")}
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            flex: 1,
                                            fontSize: "0.7rem",
                                            color: "#333",
                                            wordBreak: "break-word",
                                            lineHeight: 1.4,
                                        }}
                                    >
                                        {value !== null && value !== undefined ? String(value) : "—"}
                                    </Typography>
                                </Box>
                            ))}
                    </Box>
                )}
            </DialogContent>

            <DialogActions
                sx={{
                    px: 2,
                    py: 1,
                    borderTop: "1px solid #e0e0e0",
                    backgroundColor: "#f8f9fa",
                }}
            >
                <Button
                    onClick={onClose}
                    variant="contained"
                    size="small"
                    sx={{
                        textTransform: "none",
                        fontSize: "0.75rem",
                        px: 2.5,
                        py: 0.4,
                        minHeight: "28px",
                        boxShadow: "none",
                        "&:hover": { boxShadow: "none" },
                    }}
                >
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default RowDetailsModal;